module.exports = __webpack_public_path__ + "static/media/checkmark_disabled.23adb55b.png";